<script setup lang="ts">
import { uiText } from '../core/ui'
</script>

<template>
  <span
    class="live-refresh-status"
    role="status"
    :title="
      uiText(
        'Diese Ansicht aktualisiert sich automatisch, solange sie sichtbar ist.',
        'This view refreshes automatically while it is visible.',
      )
    "
  >
    <span class="live-refresh-dot" aria-hidden="true"></span>
    {{ uiText('Live · automatisch', 'Live · automatic') }}
  </span>
</template>
